import classNames from "classnames";
import React from "react";

export const ConversationFrame = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return <div className={styles.container}>{children}</div>;
};

ConversationFrame.Body = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.bodyContainer}>{children}</div>;
};

ConversationFrame.Header = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.headerContainer}>{children}</div>;
};

ConversationFrame.Footer = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.footerContainer}>{children}</div>;
};

const styles = {
  container: classNames(
    "tw-relative",
    "tw-flex tw-flex-col",
    "tw-flex-grow",
    "tw-overflow-hidden",
    "tw-max-h-[calc(100dvh-3.5rem)] tw-min-h-[calc(100dvh-3.5rem)] tw-flex-row md:tw-max-h-[100dvh] md:tw-min-h-[100dvh]",
  ),
  headerContainer: classNames(
    "tw-relative",
    "tw-z-10",
    "tw-flex",
    "tw-w-full",
    "tw-justify-between",
    "tw-bg-white",
  ),
  bodyContainer: classNames(
    "tw-grow",
    "tw-overflow-scroll",
    "tw-flex-col-reverse",
    "tw-flex",
  ),
  footerContainer: classNames(
    "tw-w-full",
    "tw-bg-white",
    "tw-shadow-smInverted",
    "tw-px-6 tw-pb-6 tw-pt-4",
    "tw-shadow-xsInvertedNoBlurRadius",
  ),
};
